module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_02_sp-b8a6e0c7ba893896338057989c952d55.png";